(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("apprun"));
	else if(typeof define === 'function' && define.amd)
		define(["apprun"], factory);
	else if(typeof exports === 'object')
		exports["apprun-router"] = factory(require("apprun"));
	else
		root["apprun-router"] = factory(root["apprun"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 